import React, { useMemo } from "react";
import Select from "react-select";

export const SwapList = ({ values, options, onChange, selectPlaceholder, listTitle }) => {
  const computedValues = useMemo(() => {
    return values.length ? values.map((v) => ({ value: v.id || v.value, label: v.name || v.label, order: v.pivot?.order })) : [];
  }, [values]);

  const handleOnChange = (selectedValue) => {
    onChange(selectedValue);
  };

  return (
    <div>
      <Select defaultValue={computedValues} options={options} isMulti placeholder={selectPlaceholder} onChange={handleOnChange} />

      {values && !!values.length && (
        <div className="mt-3 rounded-md bg-white shadow-md">
          <div className="bg-gray-100 px-4 py-2">
            <p className="text-md font-semibold text-gray-800">{listTitle}</p>
          </div>
          <ul className="divide-y divide-gray-200">
            {computedValues
              .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
              .map((value, index) => (
                <li className="flex items-center px-4 py-2" key={index.toString()}>
                  <span className="text-md mr-4 font-medium text-gray-600">{value.label}</span>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};
